
export const initMarqueesAndCounters = () => {
  // Load entities and populate marquees
  fetch('assets/data/entities.json')
    .then(response => response.json())
    .then(data => {
      const entities = data.entities;
      // console.log(`Entities from initMarqueesAndCounters: ${entities}`);
      
      // Function to shuffle array
      function shuffleArray(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
      }
      
      // Function to create continuous entity stream (limited selection)
      function createEntityStream(entities, count = 15) {
        const shuffled = shuffleArray(entities);
        // Take only a small subset of entities
        const selectedEntities = shuffled.slice(0, count);
        // Repeat the small selection a few times for continuous scrolling
        const stream = [...selectedEntities, ...selectedEntities, ...selectedEntities];
        return stream.join(' &nbsp; • &nbsp; ') + ' &nbsp; • &nbsp; ';
      }
      
      // Populate each marquee with different small random selections
      document.getElementById('marquee-1').querySelector('span').innerHTML = createEntityStream(entities, 12);
      document.getElementById('marquee-2').querySelector('span').innerHTML = createEntityStream(entities, 15);
      document.getElementById('marquee-3').querySelector('span').innerHTML = createEntityStream(entities, 10);
    })
    .catch(error => {
      console.error('Error loading entities:', error);
      // Fallback to lorem ipsum if JSON fails to load
      document.getElementById('marquee-1').querySelector('span').innerHTML = 'Lorem Ipsum Dolor Sit Amet &nbsp; • &nbsp; Consectetur Adipiscing Elit &nbsp; • &nbsp; Sed Do Eiusmod &nbsp; • &nbsp;';
      document.getElementById('marquee-2').querySelector('span').innerHTML = 'Ut Enim Ad Minim Veniam &nbsp; • &nbsp; Quis Nostrud Exercitation &nbsp; • &nbsp; Ullamco Laboris &nbsp; • &nbsp;';
      document.getElementById('marquee-3').querySelector('span').innerHTML = 'Duis Aute Irure Dolor &nbsp; • &nbsp; In Reprehenderit &nbsp; • &nbsp; In Voluptate Velit Esse &nbsp; • &nbsp;';
    });

  // Counter animation for stats
  const statNumbers = document.querySelectorAll('.stat-number');

  // Function to animate a single stat counter
  const animateCounter = (target) => {
    const finalNumberText = target.textContent;
    const hasPlus = finalNumberText.includes('+');
    const cleanNumber = parseFloat(finalNumberText.replace(/[^\d.]/g, ''));

    if (isNaN(cleanNumber)) return;

    let current = 0;
    // const duration = 2000; // 2 seconds for animation
    const duration = 500 // Faster duration .5 second for animation
    // const frameRate = 1000 / 60; // 60fps
    const frameRate = 1000 / 480; // 480 fps - faster frame rate
    const totalFrames = Math.round(duration / frameRate);
    const increment = cleanNumber / totalFrames;

    const updateNumber = () => {
      current += increment;
      if (current >= cleanNumber) current = cleanNumber;

      let displayNumber;
      if (cleanNumber >= 1000000000) {
        displayNumber = (current / 1e9).toFixed(1) + 'B';
      } else if (cleanNumber >= 1000000) {
        displayNumber = (current / 1e6).toFixed(1) + 'M';
      } else if (cleanNumber >= 1000) {
        displayNumber = (current / 1000).toFixed(1).replace('.0', '') + 'K';
      } else {
        displayNumber = Math.floor(current).toLocaleString();
      }

      target.textContent = displayNumber + (hasPlus ? '+' : '');

      if (current < cleanNumber) {
        requestAnimationFrame(updateNumber);
      } else {
        // Ensure final value is accurate at the end
        if (cleanNumber >= 1000000000) {
          displayNumber = (cleanNumber / 1e9).toFixed(1) + 'B';
        } else if (cleanNumber >= 1000000) {
          displayNumber = (cleanNumber / 1e6).toFixed(1) + 'M';
        } else if (cleanNumber >= 1000) {
          displayNumber = (cleanNumber / 1000).toFixed(1).replace('.0', '') + 'K';
        } else {
          displayNumber = cleanNumber.toLocaleString();
        }
        target.textContent = displayNumber + (hasPlus ? '+' : '');
      }
    };

    requestAnimationFrame(updateNumber);
  };

  // Observe when stats enter the viewport
  const statsObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  // Start observing all stat numbers
  statNumbers.forEach(stat => statsObserver.observe(stat));
};
